import { jsx, jsxs } from "react/jsx-runtime";
import { addTheme } from "@tamagui/theme";
import { useState } from "react";
import { Button, H3, Square, Theme, YStack } from "tamagui";
function AddThemeDemo() {
  const [theme, setTheme] = useState();
  return /* @__PURE__ */ jsxs(YStack, { alignItems: "center", space: true, children: [
    /* @__PURE__ */ jsxs(H3, { children: [
      "Theme: ",
      theme ?? "none"
    ] }),
    /* @__PURE__ */ jsx(Theme, { name: theme ?? "red", children: /* @__PURE__ */ jsx(Square, { borderRadius: "$8", size: 100, backgroundColor: "$color" }) }),
    /* @__PURE__ */ jsx(
      Button,
      {
        disabled: theme === "superblue",
        onPress: () => {
          addTheme({
            name: "superblue",
            insertCSS: true,
            theme: {
              background: "#000",
              color: "blue"
            }
          });
          setTheme("superblue");
        },
        children: "Add superblue theme"
      }
    )
  ] });
}
export {
  AddThemeDemo
};
//# sourceMappingURL=AddThemeDemo.js.map
